export const environment = {
    production: false,
    clientHost: 'https://qastaging.staftr.com/',
    apiUrl: 'https://qastaging.staftr.com/api/',
    adminAppUrl: 'https://adminqa.staftr.com/admin',
    tokenRefreshBefore: -2,
    dateFormat: 'MM/dd/yyyy',
    usSpecificTimezoneOnly: true,
    title: "Staftr",
    favicon: 'assets/images/favicon_staftr.ico',
    firebaseConfig :{
        apiKey: "AIzaSyAr3j3zU9oZ7OYp6ITBBgnwKUoHrEVcm7M",
        authDomain: "mplace-dd342.firebaseapp.com",
        databaseURL: "https://mplace-qa.firebaseio.com",
        projectId: "mplace-dd342",
        storageBucket: "",
        messagingSenderId: "136536185534",
        logging: true
    },
    unitTestConfig: {
        defaultPassword: "Tester@1234"
    },
    isPWCEnabled: false,
    mailToContact: 'info@mplace.io',
    privacyPolicyUrl: 'https://staftr.com/privacy-policy/',
    termsOfServiceUrl: 'https://staftr.com/terms-of-use/'
};
